// /admin/components/ChildCategoryManager.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API } from '../../api/Api';
import { FaEdit } from 'react-icons/fa';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import toast, { Toaster } from 'react-hot-toast';
import Sidebar from '../components/Sidebar';
import { BeatLoader } from 'react-spinners';

const ChildCategory = () => {
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedChild, setSelectedChild] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [newChild, setNewChild] = useState({
        name: '',
        status: true,
    });


    const { id } = useParams(); // parent ID
    const navigate = useNavigate();
    const token = localStorage.getItem('token');

    const [parentCategory, setParentCategory] = useState(null);
    const [childCategories, setChildCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchCategory = async () => {
        setLoading(true);
        const url = `${process.env.REACT_APP_API_URL}/visualizer/getvisualizermasterlist`;
        try {
            const response = await API(url, { type: 'category' }, token);
            const parent = response?.Data?.find(cat => cat.id === parseInt(id));
            setParentCategory(parent);
            setChildCategories(parent?.ChildCategory || []);
        } catch (err) {
            toast.error('Failed to load data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategory();
    }, [id]);

    const handleDelete = async (childId) => {
        const url = `${process.env.REACT_APP_API_URL}/visualizer/deletecollection`;
        try {
            setLoading(true);
            const response = await API(url, { id: childId }, token);
            if (response?.Result === 1) {
                toast.success('Child category deleted');
                fetchCategory();
            } else {
                toast.error('Failed to delete');
            }
        } catch {
            toast.error('Error deleting');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Toaster position="top-center" />

            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/80">
                    <BeatLoader size={20} />
                </div>
            )}
            <div className="flex h-screen fixed w-full bg-gray-100">
                <div className="md:w-64 w-16 bg-gray-800 transition-all">
                    <Sidebar />
                </div>
                <div className="p-6 w-full">
                    <div className="bg-white rounded-xl shadow-md overflow-auto">
                        <div className="flex justify-between items-center p-4 ">
                            {/* <h2 className="text-xl font-semibold text-teal-600">Collections</h2> */}
                            {/* <h2 className="text-xl font-bold mb-4 text-teal-600">
                                Child Categories of {parentCategory?.name}
                            </h2> */}
                            <div>
                                <p className="text-teal-500 text-2xl font-semibold">Child Categories of {parentCategory?.name}</p>
                                <p className="text-gray-600 text-sm"><span className="cursor-pointer text-teal-500" onClick={() => navigate(-1)}>Collection</span><span className='text-gray-500'>/ {parentCategory?.name}</span></p>
                            </div>
                            <button
                                onClick={() => {
                                    setNewChild({ name: '', status: true });
                                    setShowAddModal(true);
                                }}
                                className="mb-4 px-4 py-2 bg-teal-500 text-white rounded hover:bg-teal-600"
                            >
                                Add Child Category
                            </button>
                        </div>
                        <hr className="border-gray-200 mb-4" />


                        <div className='px-5 pb-4'>

                            <table className="w-full text-sm border shadow">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="p-3 text-left">Id</th>
                                        <th className="p-3 text-left">Name</th>
                                        <th className="p-3 text-left">Status</th>
                                        <th className="p-3 text-left">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {childCategories.length > 0 ? (
                                        childCategories.map((child, index) => (
                                            <tr key={child.id} className="border-b hover:bg-gray-50">
                                                <td className="p-3">{index + 1}</td>
                                                <td className="p-3">{child.name}</td>
                                                <td className="p-3">{child.status ? 'Active' : 'Inactive'}</td>
                                                <td className="p-3 flex gap-2">
                                                    <button
                                                        className="text-blue-500 hover:underline"
                                                        title="Edit"
                                                        onClick={() => {
                                                            setSelectedChild({
                                                                id: child.id,
                                                                name: child.name,
                                                                status: child.status,
                                                            });
                                                            setShowEditModal(true);
                                                        }}

                                                    >
                                                        <FaEdit size={18} />
                                                    </button>
                                                    <button
                                                        className="text-red-500 hover:underline"
                                                        title="Delete"
                                                        onClick={() => handleDelete(child.id)}
                                                    >
                                                        <MdOutlineDeleteOutline size={18} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center p-4 text-gray-500">
                                                No child categories found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </div>
                    {showEditModal && selectedChild && (
                        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center">
                            <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-xl">
                                <h2 className="text-lg font-semibold text-gray-800 mb-4">
                                    Edit Child Category
                                </h2>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-gray-700 mb-1">Name</label>
                                        <input
                                            type="text"
                                            value={selectedChild.name}
                                            onChange={(e) =>
                                                setSelectedChild({ ...selectedChild, name: e.target.value })
                                            }
                                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-400"
                                        />
                                    </div>

                                    <div className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            checked={selectedChild.status}
                                            onChange={(e) =>
                                                setSelectedChild({ ...selectedChild, status: e.target.checked })
                                            }
                                            className="w-4 h-4 text-teal-600 border-gray-300 rounded"
                                        />
                                        <label className="text-gray-700">Active</label>
                                    </div>

                                    <div className="flex justify-end gap-3 pt-4">
                                        <button
                                            onClick={() => setShowEditModal(false)}
                                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={async () => {
                                                const payload = {
                                                    id: selectedChild.id,
                                                    name: selectedChild.name,
                                                    parent_id: parseInt(id),
                                                    status: selectedChild.status ? '1' : '0',
                                                };

                                                try {
                                                    setLoading(true);
                                                    const url = `${process.env.REACT_APP_API_URL}/visualizer/createupdatecollection`;
                                                    const response = await API(url, payload, token);
                                                    if (response?.Result === 1) {
                                                        toast.success('Child category updated');
                                                        setShowEditModal(false);
                                                        fetchCategory(); // Refresh list
                                                    } else {
                                                        toast.error('Update failed');
                                                    }
                                                } catch (err) {
                                                    toast.error('Error while updating');
                                                } finally {
                                                    setLoading(false);
                                                }
                                            }}
                                            className="px-4 py-2 bg-teal-500 text-white rounded hover:bg-teal-600"
                                        >
                                            Update
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {showAddModal && (
                        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center">
                            <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-xl">
                                <h2 className="text-lg font-semibold text-gray-800 mb-4">
                                    Add Child Category
                                </h2>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-gray-700 mb-1">Name</label>
                                        <input
                                            type="text"
                                            value={newChild.name}
                                            onChange={(e) =>
                                                setNewChild({ ...newChild, name: e.target.value })
                                            }
                                            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-400"
                                        />
                                    </div>

                                    <div className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            checked={newChild.status}
                                            onChange={(e) =>
                                                setNewChild({ ...newChild, status: e.target.checked })
                                            }
                                            className="w-4 h-4 text-teal-600 border-gray-300 rounded"
                                        />
                                        <label className="text-gray-700">Active</label>
                                    </div>

                                    <div className="flex justify-end gap-3 pt-4">
                                        <button
                                            onClick={() => setShowAddModal(false)}
                                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={async () => {
                                                const payload = {
                                                    id: null,
                                                    name: newChild.name,
                                                    parent_id: parseInt(id),
                                                    status: newChild.status ? '1' : '0',
                                                };

                                                try {
                                                    setLoading(true);
                                                    const url = `${process.env.REACT_APP_API_URL}/visualizer/createupdatecollection`;
                                                    const response = await API(url, payload, token);
                                                    if (response?.Result === 1) {
                                                        toast.success('Child category added');
                                                        setShowAddModal(false);
                                                        fetchCategory(); // Refresh list
                                                    } else {
                                                        toast.error('Add failed');
                                                    }
                                                } catch (err) {
                                                    toast.error('Error while adding');
                                                } finally {
                                                    setLoading(false);
                                                }
                                            }}
                                            className="px-4 py-2 bg-teal-500 text-white rounded hover:bg-teal-600"
                                        >
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </>

    );
};

export default ChildCategory;
